const Logo = ({
  className = 'h-16',
  showText = false,
  subtitle = null,
  variant = 'primary',
}) => {
  const isInverse = variant === 'inverse';
  const brandTextClass = isInverse ? 'text-white' : 'text-primary';
  const subtitleClass = isInverse ? 'text-white/70' : 'text-primary/70';
  const taglineClass = isInverse ? 'text-white/80' : 'text-primary/80';

  return (
    <div className={`flex items-center justify-center gap-3 ${className}`}>
      <div className="flex flex-col items-center justify-center gap-1">
        <div className={`flex flex-wrap items-baseline justify-center drop-shadow-sm ${brandTextClass}`}>
          <span className="text-2xl tracking-tight">Globo</span>
          <span className="text-2xl font-bold tracking-tight text-secondary-light">ERP</span>
        </div>

        {subtitle ? (
          <p className={`text-[10px] font-medium uppercase tracking-[0.15em] ${subtitleClass}`}>
            {subtitle}
          </p>
        ) : null}

        {showText ? (
          <p className={`text-xs uppercase tracking-[0.28em] ${taglineClass}`}>
            ERP System • Globotech
          </p>
        ) : null}
      </div>
    </div>
  );
};

export default Logo;

